import React, { Component } from 'react';

import { homePage } from '../../../data';

import { getRandomInt } from '../../helpers/GeneralHelpers';

import '../../../css/components/home-page-banner.scss';

export class HomePageBanner extends Component {
  constructor(props){
    super(props);
    const {
      bannerImages,
    } = homePage;

    this.state = {
      randomIndex: getRandomInt(0, bannerImages.length - 1),
    }
  }

  render(){
    const {
      randomIndex
    } = this.state;
    
    const {
      bannerImages,
    } = homePage;

    return (
      <div className="home-page-banner">
        <div className="image-wrapper">
          <img className="banner-image" alt="test" src={ bannerImages[randomIndex].imageSrc } />
        </div>

        <div className="banner-content">
          <div className="space-holder">

          </div>
          <div className="banner-text">
            <div className="text">
              { bannerImages[randomIndex].text }
            </div>
            <div className="line-container"></div>
          </div>
        </div>
        
      </div>
    )
  }
}
